import { useStyle } from 'react-native-style-utilities';

import { theme, useContainerSpacing } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Home is expected to have a minimum padding of 24px.
 */
export const useHomeContainerSpacing = () => {
  const containerSpacing = useContainerSpacing();

  return useStyle(
    () => ({ paddingHorizontal: Math.max(containerSpacing, theme.spacing['6']) }),
    [containerSpacing],
  );
};
